import config from './config.js'
import axios from 'axios'
import xmlConverter from './xmlConverter.js'

// methods
import getSourceCountries from './templates/getSourceCountries.js'
import getPayingCurrencies from './templates/getPayingCurrencies.js'
import getDestinationCountries from './templates/getDestinationCountries.js'
import getServiceProviders from './templates/getServiceProviders.js'
import getCountryCities from './templates/getCountryCities.js'
import getBranchesByServiceProvider from './templates/getBranchesByServiceProvider.js'
import getPayoutCurrencies from './templates/getPayoutCurrencies.js'
import getPrice from './templates/getPrice.js'
import getLocations from './templates/getLocations.js'
import getNetworkCountries from './templates/getNetworkCountries.js'
import getRemittanceStatus from './templates/getRemittanceStatus.js'

const templates = {
  getSourceCountries,
  getPayingCurrencies,
  getDestinationCountries,
  getServiceProviders,
  getCountryCities,
  getBranchesByServiceProvider,
  getPayoutCurrencies,
  getPrice,
  getLocations,
  getNetworkCountries,
  getRemittanceStatus
}

const mode = 'production' // change to production

async function makeRequest(props) {
  try {
    const { method, platform, params } = props

    const credentials = config.credentials[mode]
    const xml = templates[method]({...credentials, ...params})
    const platformUrl = config.platform[mode][platform]

    const xmlResult = await axios.post(platformUrl, xml, {headers: { 'Content-Type': 'text/xml' }})

    const parsedResult = await xmlConverter(xmlResult.data, method)

    if (!parsedResult) return []

    return parsedResult
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function _getSourceCountries(platform = 'UK') {
  const result = await makeRequest({
    method: 'getSourceCountries',
    platform
  })

  return result
}

export async function _getPayingCurrencies(sourceCountryId, platform = 'UK') {
  const result = await makeRequest({
    method: 'getPayingCurrencies',
    platform,
    params: {
      sourceCountryId
    }
  })

  return result
}

export async function _getDestinationCountries(sourceCountryId, platform = 'UK') {
  const result = await makeRequest({
    method: 'getDestinationCountries',
    platform,
    params: {
      sourceCountryId
    }
  })

  return result
}

export async function _getServiceProviders(sourceCountryId, destinationCountryId, serviceType, platform = 'UK') {
  const result = await makeRequest({
    method: 'getServiceProviders',
    platform,
    params: {
      sourceCountryId,
      destinationCountryId,
      serviceType
    }
  })

  return result
}

export async function _getCountryCities(countryId, platform = 'UK') {
  const result = await makeRequest({
    method: 'getCountryCities',
    platform,
    params: {
      countryId // destination country id
    }
  })

  return result
}

export async function _getBranchesByServiceProvider(cityCode, serviceProviderId, serviceType, platform = 'UK') {
  const result = await makeRequest({
    method: 'getBranchesByServiceProvider',
    platform,
    params: {
      cityCode,
      serviceProviderId,
      serviceType
    }
  })

  return result
}

export async function _getPayoutCurrencies(destinationCountryId, serviceProviderId, serviceType, platform = 'UK', payoutBranchCode = '') {
  const result = await makeRequest({
    method: 'getPayoutCurrencies',
    platform,
    params: {
      destinationCountryId,
      serviceProviderId,
      serviceType,
      payoutBranchCode
    }
  })

  return result
}

export async function _getPrice(
    serviceType,
    serviceProviderId,
    sourceCountryId,
    destinationCountryId,
    payingCurrencyId,
    payoutCurrencyId,
    payingAmount,
    payoutAmount,
    platform = 'UK',
    payoutBranchCode = ''
) {

  const result = await makeRequest({
    method: 'getPrice',
    platform,
    params: {
      serviceType,
      serviceProviderId,
      sourceCountryId,
      destinationCountryId,
      payingCurrencyId,
      payoutCurrencyId,
      payingAmount,
      payoutAmount,
      payoutBranchCode
    }
  })

  return result
}

export async function _getLocations(countryId, cityCode, platform = 'UK') {
  const result = await makeRequest({
    method: 'getLocations',
    platform,
    params: {
      countryId,
      cityCode
    }
  })

  console.log(countryId, cityCode)

  return result
}

export async function _getNetworkCountries(platform = 'UK') {
  const result = await makeRequest({
    method: 'getNetworkCountries',
    platform
  })

  return result
}

export async function _getRemittanceStatus(remittancTrackingCode, platform = 'UK') {
  try {
    const result = await makeRequest({
      method: 'getRemittanceStatus',
      platform,
      params: {
        remittancTrackingCode
      }
    })

    return result
  } catch (error) {
    return error.message
  }
}
